import { CKEditor } from "@ckeditor/ckeditor5-react";
import { ClassicEditor } from "ckeditor5";
import { editorConfig } from "./editorConfig";
import { MyUploadAdapter } from "./MyUploadAdapter";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onUpload: (image: { url: string; public_id: string }) => void;
};

export default function RichTextEditor({ value, onChange, onUpload }: Props) {
  return (
    <CKEditor
      editor={ClassicEditor}
      config={editorConfig}
      data={value}
      onReady={(editor) => {
        editor.plugins.get("FileRepository").createUploadAdapter = (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          loader: any,
        ) => {
          return new MyUploadAdapter(loader, onUpload);
        };
      }}
      onChange={(_event, editor) => {
        onChange(editor.getData());
      }}
    />
  );
}
